import { CONTRACT_GLOBALS_ERROR, ADD_TOAST_MESSAGE } from './Redux/Enums/Contracts.Globals.Enums';

export const isErrorCode = (error, code) => {
	return error.name === 'Error' && error.message.indexOf(`status code ${code}`) > 0;
};

export const debounce = (func, delay) => {
	let timerId;
	return (...args) => {
		const boundFunc = func.bind(this, ...args);
		clearTimeout(timerId);
		timerId = setTimeout(boundFunc, delay);
	};
};

export const addKeyField = (data, prop1, prop2, propName) => {
	if (!Array.isArray(data)) {
		return data;
	}
	return data.map(item => Object.assign(item, { [propName]: `${item[prop1]}_${item[prop2]}` }));
};

export const isNullOrUndefined = input => input === null || input === undefined;

export const isNullUndefinedOrEmpty = input => {
	if (isNullOrUndefined(input)) {
		return true;
	}
	if (typeof input === 'string' && input.trim() === '') {
		return true;
	}
	return false;
};

export const hasValue = input => !isNullUndefinedOrEmpty(input);

export const isInPast = date => {
	if (isNullUndefinedOrEmpty(date)) {
		return null;
	}
	const inputDate = date instanceof Date ? date : new Date(date);
	return inputDate.getTime() < new Date().getTime();
};

export const isInFuture = date => {
	if (isNullUndefinedOrEmpty(date)) {
		return null;
	}
	return !isInPast(date);
};

export const createErrorAction = errors => {
	return {
		type: CONTRACT_GLOBALS_ERROR,
		payload: { errors }
	};
};

export const errorToastAction = message => {
	return {
		type: ADD_TOAST_MESSAGE,
		payload: {
			severity: 'error',
			message
		}
	};
};

export const warningToastAction = message => {
	return {
		type: ADD_TOAST_MESSAGE,
		payload: {
			severity: 'warning',
			message
		}
	};
};

export const infoToastAction = message => {
	return {
		type: ADD_TOAST_MESSAGE,
		payload: {
			severity: 'info',
			message
		}
	};
};

export const successToastAction = message => {
    return {
        type: ADD_TOAST_MESSAGE,
        payload: {
            severity: 'success',
            message
        }
    };
};

export const compare = (first, second) => {
    if (isNullOrUndefined(first)) {
        return second == null ? 0 : -1;
    }

    if (isNullOrUndefined(second))
        return 1;

    if (first === second)
        return 0

    return first < second ? -1 : 1;
}

export const makeStyles = classNames => {
    return (...names) => names
		.filter(name => name && typeof(name) === 'string' && name.length > 0)
		.map(name => classNames[name] || name)
		.join(' ');
};

export const convertToDate = value => {
	if (isNullUndefinedOrEmpty(value)) {
		return null;
	}

	if (typeof(value) === 'string') {
		const dateValue = new Date(value);
		return !isNaN(dateValue) ? dateValue : null;
	}

	if (value instanceof Date) {
		return value;
	}

	return null;
};

export const formatDate = value => {
	if (isNullUndefinedOrEmpty(value)) {
		return '';
	}

	if (!isValidDate(value)) {
		return '<invalid date>';
	}

	return `${value.getDate()}/${value.getMonth() + 1}/${value.getFullYear()}`;
}

/**
 * Returns a string representing the given date in ISO 8601 format, ignoring timezones.
 * @param {Date} value A Date object.
 */
export const serializeDate = value => {
	if (!isValidDate(value)) {
		return '';
	}

	return asUTCDate(value).toISOString();
}

const asUTCDate = (value) => {
    // Returns the given date as a literal value in UTC, without applying any timezone.
	if (isValidDate) {
		return new Date(Date.UTC(value.getFullYear(), value.getMonth(), value.getDate(),
			value.getHours(), value.getMinutes(), value.getSeconds(), value.getMilliseconds()));
	}

	return new Date(NaN);
}

const isValidDate = (value) => {
	return hasValue(value) && (value instanceof Date) && !isNaN(value);
}

export const startsWith = (value, target) => {
    if (typeof(value) === 'string') {
        return value.slice(0, target.length) === target;
    }

    return false;
}